import { useMemo } from 'react';
import { EntryStage } from "../../types";

export function useStageInfo(stage: EntryStage) {
    return useMemo(() => {
        return {
            stage,
            stageName: getStageName(stage),
            stagePath: getStagePath(stage)
        }
    }, [stage]);

    function getStageName(stage: EntryStage): string {
        switch (stage) {
            case 3:
                return `二次審査`;
            case 4:
                return `三次審査`;
            case 5:
                return "四次審査";
            case 6:
                return "セミファイナル";
            case 7:
                return "ファイナル";
            default:
                return ""
        }
    }

    function getStagePath(stage: EntryStage): string {
        switch (stage) {
            case 3:
                return `/list/2`;
            case 4:
                return `/list/3`;
            case 5:
                return `/list/4`;
            case 6:
                return `/list/semifinal`;
            case 7:
                return `/list/final`;
            default:
                return `/list`;
        }
    }
}